import { Box, Button, SxProps, Typography } from '@mui/material'

import { useSessionDispatch } from 'context/Session'

const style: Record<string, SxProps> = {
  wrap: {
    display: 'flex',
    width: '100vw',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginBottom: 1,
    textAlign: 'center',
  },
  btwWrap: {
    display: 'flex',
  },
  prevBtn: {
    marginRight: 'auto',
    marginLeft: 'auto',
  },
}

export default function ErrorFallbackContent(): JSX.Element {
  const { wrap, btwWrap, text, prevBtn } = style

  const [dispatch] = useSessionDispatch()

  const goToPrevPage = (): void => {
    dispatch({ type: 'popStep' })
  }

  return (
    <Box sx={wrap}>
      <Box>
        <Typography sx={text}>Sorry, but something went wrong</Typography>
        <Box sx={btwWrap}>
          <Button sx={prevBtn} onClick={goToPrevPage} variant="contained">
            Go back to prev page
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
